import { render, staticRenderFns } from "./maintenanceStatistics.vue?vue&type=template&id=5f09a5f6"
import script from "./maintenanceStatistics.vue?vue&type=script&lang=js"
export * from "./maintenanceStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports